import React from 'react';
import { Main } from '../../containers/main/Main';
import "./sass/dashBoard.css";

export const DashBoard = ({menu}) => {

   return (
      <Main menu={menu}/>
   );
} 
